import React, { useState, useEffect, useCallback, useRef } from "react";
import _ from "lodash";
import * as Icon from "react-bootstrap-icons";
import { Card, Image, Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getFromLS, setToLS } from "../../utils/storage";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { ThreeCircles, Bars } from "react-loader-spinner";
import { logout } from "../../utils";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import styled from 'styled-components';
import dashboard_settings from '../../dashboard_settings/dashboard_settings.json';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { useNavigate } from "react-router-dom";
import './ReportDashboard.css'
import { NoAccessPopup } from "../../reusable-components/NoAccessPopupComponent/NoAccessModal";


require("highcharts/modules/accessibility")(Highcharts);

const ColumnContainer = styled.div`
  margin: 8px 0px 8px 16px;
  border: 0px solid #bbb;
  border-radius: 2px;
  background-color: #fbfbfc;

  display: flex;
  flex-direction: column;
`;
const Title = styled.h3`
  padding: 8px;
`;
const ReportList = styled.div`
  padding: 8px;
  transition: background-color 0.2 ease;
  background-color: ${props => (props.isDraggingOver ? 'white' : '#fbfbfc')};
  border: 1px solid ${props => (props.isDraggingOver ? '#e9e9e9' : '#fbfbfc')};
  flex-grow: 1;
  min-height: 75vh;
`;

const ReportContainer = styled.div`
border: 1px solid #e9e9e9;
border-radius: 10px;
margin:0px;
background-color: ${props => (props.isDragging ? '#e9e9e9' : 'white')};
min-height: 100px;
padding:8px;
width: 100%;
height: 100%;
transition: 0.375s ease;
&:hover {
  box-shadow: 0px 2px 8px 0px rgb(0 0 0 / 20%);
}
`;

const DragDropContextContainer = styled.div`
padding-left: 0%;
padding-right: 1%;
display: flex;
`
// This is internal report mapper for intelligence report
const REPORT_MAPPER = {
  "Monthly Task Status": "MonthlyTaskStatusReport",
  "Jurisdictions": "JurisdictionReport",
  "Capacity vs Billable and Non-billable": "BillableReport",
  "Staffing": "StaffingReport",
  "Task Details": "TaskDetailsReport",
  "Roles Engagement": "RolesEngagement",
  "Turn Around Time": "ComingSoonTemplate",
  "Work Distribution": "WorkDistributionReport",
};

const ReportDashboard = (report_dashboard_props) => {
  // console.log("REPORT DASHBOARD PROPS: ", report_dashboard_props)
  const [firm_id, setFirmId] = useState(localStorage.getItem("firmId"));
  const [vendor, setVendor] = useState("xcm");
  const [reports, setReports] = useState([]);
  const [reportView, setReportView] = useState([]);
  const [allReportsFlag, setAllReportsFlag] = useState([])
  const [reportToggle, setReportToggle] = useState(false);
  const [favoriteReports, setFavoriteReports] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [dashBoardConfigState, setDashboardConfigState] = useState();
  const [saveDashboardSettingToggle, setSaveDashboardSettingToggle] = useState(true);
  const localChartTheme = getFromLS("chart-theme");
  const dashboard_config = getFromLS('dashboard-config')
  const navigate = useNavigate();
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ firm_id, vendor }),
  };
  let drag_data_format = dashboard_config != null ? dashboard_config : dashboard_settings.initial_data;
  const setReporter = (reps) => {
    // console.log("Reports: ", reps.data[0].reports);
    // console.log("DRAG DATA FORMAT: ", drag_data_format);
    // console.log("DASHBOARD SETTINGS: ", JSON.stringify(drag_data_format) == JSON.stringify(dashboard_settings.initial_data))
    let reports = reps.data[0].reports;
    if (drag_data_format == undefined || JSON.stringify(drag_data_format) == JSON.stringify(dashboard_settings.initial_data)) {
      drag_data_format = {
        "reports": {},
        "columns": {
          "column-1": {
            "id": "column-1",
            "reportIds": []
          },
          "column-2": {
            "id": "column-2",
            "reportIds": []
          },
          "column-3": {
            "id": "column-3",
            "reportIds": []
          }
        },
        "columnOrder": [
          "column-1",
          "column-2",
          "column-3"
        ],
        "default_view": "list"
      }
      for (let report in reports) {
        drag_data_format["reports"][reports[report].report_name] = {
          "id": reports[report].report_name,
          "content": reports[report]
        }
        if (drag_data_format["columns"]["column-1"].reportIds.length
          == drag_data_format["columns"]["column-2"].reportIds.length &&
          drag_data_format["columns"]["column-2"].reportIds.length
          == drag_data_format["columns"]["column-3"].reportIds.length) {
          drag_data_format["columns"]["column-1"].reportIds.push(reports[report].report_name)
        }
        else if (drag_data_format["columns"]["column-1"].reportIds.length
          > drag_data_format["columns"]["column-2"].reportIds.length &&
          drag_data_format["columns"]["column-2"].reportIds.length
          == drag_data_format["columns"]["column-3"].reportIds.length) {
          drag_data_format["columns"]["column-2"].reportIds.push(reports[report].report_name)
        }
        else if (drag_data_format["columns"]["column-1"].reportIds.length
          == drag_data_format["columns"]["column-2"].reportIds.length &&
          drag_data_format["columns"]["column-2"].reportIds.length
          > drag_data_format["columns"]["column-3"].reportIds.length) {
          drag_data_format["columns"]["column-3"].reportIds.push(reports[report].report_name)
        }
      }
      // console.log("DRAG DATA FORMAT: ", drag_data_format);
      setToLS("dashboard-config", drag_data_format)
      setData(drag_data_format)
    }
    if (drag_data_format.default_view == "favorites") {
      setReportToggle(true)
    } else {
      setReportToggle(false)
    }
    setReports(reports);
    const fav_reports = []
    for (let report in reports) {
      if (reports[report].is_favourite) {
        fav_reports.push(reports[report])
      }
    }
    setFavoriteReports(fav_reports)
    setReportView(fav_reports);
    return reps;
  };

  const get_dashboard_configuration = () => {
    const parameter_name = "dashboard_config";
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ firm_id, parameter_name }),
    };
    fetch(
      `${process.env.REACT_APP_BASE_URI}/workflow/personalization/get_params/`,
      requestOptions
    )
      .then((result) => result.json())
      .then((result) => dashboardConfigStateUpdater(result));
  };
  const dashboardConfigStateUpdater = (result) => {
    console.log("DASHBOARD CONFIG: ", result)
    console.log("DASHBOARD SETTINGS: ", dashboard_settings)
    if (result != undefined) {
      if (result.data[0].params.length == 0) {
        setToLS("dashboard-config", dashboard_settings.initial_data);
      } else if (
        result.data[0].params[0].parameter_name == "dashboard_config"
      ) {
        setToLS(
          "dashboard-config",
          JSON.parse(result.data[0].params[0].parameter_value_1)
        );
      }
    } else {
      setToLS("dashboard-config", dashboard_settings.initial_data);
    }
    return;
  };
  useEffect(() => {
    get_dashboard_configuration();
  }, []);

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_BASE_URI}/api/all_reports/`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((reps) => setReporter(reps))
      .then((reps) => {
        setAllReportsFlag(reps.data[0].reports)
        setToLS("all_reports", reps.data[0].reports)
      })
    // .then(()=> get_dashboard_configuration())
    // .then(get_favorite_reports());
    setTimeout(() => {
      setLoading(false);
    }, 6000);
  }, []);

  const save_dashboard_configutaion = (initialData) => {
    const parameter_value_1 = JSON.stringify(initialData);
    const parameter_name = "dashboard_config";
    const payload = { firm_id, parameter_name, parameter_value_1 };
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    };
    fetch(
      `${process.env.REACT_APP_BASE_URI}/workflow/personalization/set_params/`,
      requestOptions
    ).then((response) => {
      if (!response.ok) {
        if (response.status === 401) {
          // Handle unauthorized error
          logout();
          alert("Session ended , Please login back");
        } else {
          throw new Error("Request failed.");
        }
      }
      return response.json();
    });
  };

  const Column = (column_props) => {
    return (
      <ColumnContainer>
        {/* <Title>{column_props.column.title}</Title> */}
        <Droppable droppableId={column_props.column.id}>
          {(provided, snapshot) => (
            <div ref={provided.innerRef} {...provided.droppableProps} >
              <div className="report-list" isDraggingOver={snapshot.isDraggingOver}>
                {column_props.reports.map((report, index) => (
                  <ReportCardMini key={report.id} report={report} index={index} />
                ))}
              </div>
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </ColumnContainer>
    );
  }

  const ReportCardMini = (report_card_mini_props) => {
    const DotsConnector = (props) => {
      return (
        <>
          <div className="flowing-loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </>
      );
    };
    const [favorite, setFavorite] = useState(!report_card_mini_props.report.content.is_favourite);
    const categories = report_card_mini_props.report.content.thumbnail.categories || [];
    const [hideReportTitle, setHideReportTitle] = useState(false)
    const [primarySeries, setPrimarySeries] = useState({});
    const handleClick = () => {
      setFavorite(!favorite);
      if (favorite == true) {
        const index = favoriteReports.findIndex(
          (element) => element.report_name === report_card_mini_props.report.content.report_name
        );
        const indexAll = reports.findIndex(
          (element) => element.report_name === report_card_mini_props.report.content.report_name
        );
        if (index == -1) {
          console.log(
            "Updating the favourite value when added to fgavourite in all_reports",
            reports
          );
          console.log("Report to be updated in all_reports", report_card_mini_props.report);
          report_card_mini_props.report.content.is_favourite = true;
          favoriteReports.push(report_card_mini_props.report.content);
          if (indexAll !== -1) {
            reports[indexAll].is_favourite = true;
          }
          setToLS("favorite_reports", favoriteReports);
          setToLS("all_reports", reports);
          // set_favorite_reports(favoriteReports);
          updateAllReportFav(report_card_mini_props.report.content.report_name, favorite);
        }
      } else {
        const index = favoriteReports.findIndex(
          (element) => element.report_name === report_card_mini_props.report.content.report_name
        );
        const indexAll = reports.findIndex(
          (element) => element.report_name === report_card_mini_props.report.content.report_name
        );
        if (index !== -1) {
          console.log(
            "Updating the favourite value when added to fgavourite in all_reports",
            reports
          );
          console.log("Report to be updated in all_reports", report_card_mini_props.report);
          favoriteReports.splice(index, 1);
          if (indexAll !== -1) {
            reports[indexAll].is_favourite = false;
          }
          setToLS("favorite_reports", favoriteReports);
          setToLS("all_reports", reports);
          // set_favorite_reports(favoriteReports);
          updateAllReportFav(report_card_mini_props.report.content.report_name, favorite);
        }
      }
    };

    useEffect(() => {
      setPrimarySeries(report_card_mini_props.report.content.thumbnail.data);
      // console.log("REPORT CARD MINI:", report_card_mini_props)
    }, [report_card_mini_props.report.content.thumbnail.data]);

    const primaryOptions = {

      chart: {
        type: report_card_mini_props.report.content.type_of_chart,
        height: 90,
        width: 90,
        backgroundColor: "var(--card_body_color)",
        color: "var(--text_color)"
      },
      marginRight: -100,
      colors: localChartTheme.colors,
      legend: {
        enabled: false,
      },
      title: {
        align: "center",
        text: "",
        style: {
          fontSize: '12px',
          textOutline: false,
          color: "var(--text_color)"
        }
      },
      xAxis: {
        type: "category",
        title: "",
        categories: categories,
        labels: {
          enabled: false,
        },
      },
      yAxis: {
        title: "",
        labels: {
          enabled: false,
        },
      },
      plotOptions: {
        series: {
          borderWidth: 1,
          dataLabels: {
            enabled: false,
          },
          cursor: "pointer",
        },
      },
      series:
        report_card_mini_props.report.content.type_of_chart == "bar" ||
          report_card_mini_props.report.content.type_of_chart == "column"
          ? primarySeries
          : {
            name: report_card_mini_props.report.content.report_name,
            colorByPoint: true,
            data: primarySeries,
          },
      tooltip: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
    };

    const openReport = () => {
      console.log("REPORT CARD ID: ", report_card_mini_props.report.id)
      // navigate(report_card_mini_props.report.content.url)
      report_dashboard_props.transporter(REPORT_MAPPER[report_card_mini_props.report.id], { report_navigator: true })
    }

    return (
      <Draggable draggableId={report_card_mini_props.report.id} index={report_card_mini_props.index}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            className="report-card-mini-wrapper"
          >
            <ReportContainer
              {...provided.draggableProps}
              isDragging={snapshot.isDragging}
              className="row report-container">
              <div className="col-md-3 list-report-icon">
                <div {...provided.dragHandleProps} className="report-dragger">
                  <Icon.GripVertical />
                </div>
                <button className="btn-mini-card" onClick={() => openReport()}>
                  <HighchartsReact
                    highcharts={Highcharts}
                    options={primaryOptions}
                  />
                </button>
              </div>
              <div className={`list-report-card col-md-7 ${hideReportTitle ? "hide-report-info" : ""}`}>
                <span className={`list-report-title`}>{report_card_mini_props.report.content.report_name} Report</span><br />
                {/* <span className="list-report-description">{report_card_mini_props.report.content.description}</span> */}
                <div className="intelligence-flow-logo-wrapper">
                  {report_card_mini_props.report.content.source_vendors != undefined && report_card_mini_props.report.content.target_vendors != undefined
                    ?
                    <>
                      <Image src={report_card_mini_props.report.content.source_vendors[0].VendorLogoLink} className="vendor-logo-micro" rounded />
                      <DotsConnector />
                      <Image src={report_card_mini_props.report.content.target_vendors[0].VendorLogoLink} className="vendor-logo-micro" rounded />
                    </>
                    : <></>
                  }
                </div>
              </div>
              <div className="col-md-2 list-report-fav-container">
                <div className="toggle favorite-item heart" onClick={handleClick}>
                  {favorite ? <Icon.Heart /> : <Icon.HeartFill />}
                </div>
                <button className="btn-mini-card" onClick={() => openReport()}>
                  <Icon.ArrowRightCircleFill className="report-transporter" />
                </button>
                <div style={{ height: "20px" }}></div>
              </div>
              <div id="show-report-description" className="show-report-description">
                <Icon.QuestionCircleFill className="report-info-icon"
                  onMouseEnter={() => {
                    setHideReportTitle(true)
                  }}
                  onMouseLeave={() => {
                    setHideReportTitle(false)
                  }}
                />
              </div>
              <div id="report-overlay" className="report-overlay">
                <p>{report_card_mini_props.report.content.description}</p>
              </div>
            </ReportContainer>

          </div>
        )}
      </Draggable>
    );
  }

  const ReportCard = (report_card_props) => {
    const [favorite, setFavorite] = useState(!report_card_props.report.is_favourite);
    const categories = report_card_props.report.thumbnail.categories || [];
    const [primarySeries, setPrimarySeries] = useState({});
    const handleClick = () => {
      setFavorite(!favorite);
      if (favorite == true) {
        const index = favoriteReports.findIndex(
          (element) => element.report_name === report_card_props.report.report_name
        );
        const indexAll = reports.findIndex(
          (element) => element.report_name === report_card_props.report.report_name
        );
        if (index == -1) {
          console.log(
            "Updating the favourite value when added to fgavourite in all_reports",
            reports
          );
          console.log("Report to be updated in all_reports", report_card_props.report);
          report_card_props.report.is_favourite = true;
          favoriteReports.push(report_card_props.report);
          if (indexAll !== -1) {
            reports[indexAll].is_favourite = true;
          }
          setToLS("favorite_reports", favoriteReports);
          setToLS("all_reports", reports);
          // set_favorite_reports(favoriteReports);
          updateAllReportFav(report_card_props.report.report_name, favorite);
        }
      } else {
        const index = favoriteReports.findIndex(
          (element) => element.report_name === report_card_props.report.report_name
        );
        const indexAll = reports.findIndex(
          (element) => element.report_name === report_card_props.report.report_name
        );
        if (index !== -1) {
          console.log(
            "Updating the favourite value when added to fgavourite in all_reports",
            reports
          );
          console.log("Report to be updated in all_reports", report_card_props.report);
          favoriteReports.splice(index, 1);
          if (indexAll !== -1) {
            reports[indexAll].is_favourite = false;
          }
          setToLS("favorite_reports", favoriteReports);
          setToLS("all_reports", reports);
          // set_favorite_reports(favoriteReports);
          updateAllReportFav(report_card_props.report.report_name, favorite);
        }
      }
    };

    useEffect(() => {
      setPrimarySeries(report_card_props.report.thumbnail.data);
    }, [report_card_props.report.thumbnail.data]);

    const primaryOptions = {
      chart: {
        type: report_card_props.report.type_of_chart,
        innerWidth: 80,
        backgroundColor: "var(--card_body_color)",
        color: "var(--text_color)",
      },
      marginRight: -100,
      colors: localChartTheme.colors,
      title: {
        align: "center",
        text: report_card_props.report.report_name,
        style: {
          textOutline: false,
          color: "var(--text_color)",
        },
      },
      xAxis: {
        categories: categories,
        gridLineWidth: 1,
        gridLineColor: "d8d8d8",
        title: {
          style: {
            textOutline: false,
            color: "var(--text_color)",
          },
        },
        labels: {
          style: {
            textOutline: false,
            color: "var(--text_color)",
          },
        },
      },
      yAxis: {
        gridLineWidth: 1,
        gridLineColor: "#d8d8d8",
        title: {
          style: {
            textOutline: false,
            color: "var(--text_color)",
          },
        },
        labels: {
          style: {
            textOutline: false,
            color: "var(--text_color)",
          },
        },
      },
      legend: {
        itemStyle: {
          textOutline: false,
          color: "var(--text_color)",
        },
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            // distance: -10,
            style: {
              textOutline: false,
              color: "var(--text_color)",
            },
          },
          cursor: "pointer",
        },
      },
      series:
        report_card_props.report.type_of_chart == "bar" ||
          report_card_props.report.type_of_chart == "column"
          ? primarySeries
          : {
            name: report_card_props.report.report_name,
            colorByPoint: true,
            data: primarySeries,
          },
      tooltip: {
        headerFormat: '<span style="font-size: var(--default)"></span><br>',
        pointFormat:
          '<span style="color:{point.color}">{point.name}</span> <b>{point.y:,.0f}</b> of total<br/>',
      },
      exporting: {
        enabled: false,
      },
    };

    return (
      <Col className="card-container-dashboard" md="4">
        <Card>
          <Link to={report_card_props.report.url} className="normal-text">
            <div className="chart-container">
              <HighchartsReact
                highcharts={Highcharts}
                options={primaryOptions}
              />
            </div>
          </Link>
          <Card.Body>
            <div className="favorite-bar">
              <div className="favorite-item">
                <Card.Text>{report_card_props.report.description}</Card.Text>
              </div>
              <div className="toggle favorite-item heart" onClick={handleClick}>
                {favorite ? (
                  <div>
                    <Icon.Heart />
                  </div>
                ) : (
                  <div>
                    <Icon.HeartFill />
                  </div>
                )}
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>
    );
  };

  const [initialData, setData] = useState(drag_data_format);

  const updateAllReportFav = (repn, is_fav) => {
    const set_to = is_fav;
    const report_name = repn;
    const payload = { firm_id, report_name, set_to };
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    };
    console.log(requestOptions);
    fetch(
      `${process.env.REACT_APP_BASE_URI}/workflow/personalization/set_favourite/`,
      requestOptions
    ).then((response) => {
      if (!response.ok) {
        if (response.status === 401) {
          // Handle unauthorized error
          logout();
          alert("Session ended , Please login back");
        } else {
          throw new Error("Request failed.");
        }
      }
      return response.json();
    });
  };

  const viewReports = () => {
    setReportToggle((reportToggle) => !reportToggle);
  };

  const saveDashboardSettings = (data) => {
    console.log("Settings data to be saved: ", data)
    setToLS("dashboard-config", data)
    save_dashboard_configutaion(data)
  }

  const saveDashboardViewSettings = (toggle_fav, data) => {
    if (toggle_fav) {
      data.default_view = "favorites"
    }
    else if (!toggle_fav) {
      data.default_view = "list"
    }
    console.log("Default view updated: ", data)
    setToLS("dashboard-config", data)
    save_dashboard_configutaion(data)
  }

  const Switch = ({ isToggled, onToggle }) => {
    return (
      <>
        <label className="report-view-toggler">
          <input type="checkbox" checked={isToggled} onChange={onToggle} />
          {reportToggle ? (
            <Icon.HeartFill className="dashboard-view-heart" />
          ) : (
            <Icon.Stack className="dashboard-view-heart" />
          )}
        </label>

      </>
    );
  };

  if (isLoading) {
    return (
      <div>
        <Row className="dashboard-row">
          <div className="spinner-container">
            <div className="spinner">
              <Bars
                height="80"
                width="80"
                color="var(--theme1_primary)"
                ariaLabel="bars-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
              />
              <h5>Loading all reports</h5>
            </div>
          </div>
        </Row>
      </div>
    );
  }

  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;

    if (!destination) {
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    const start = initialData.columns[source.droppableId];
    const finish = initialData.columns[destination.droppableId];

    if (start === finish) {
      const newReportIds = Array.from(start.reportIds);
      newReportIds.splice(source.index, 1);
      newReportIds.splice(destination.index, 0, draggableId);

      const newColumn = {
        ...start,
        reportIds: newReportIds,
      };

      const newState = {
        ...initialData,
        columns: {
          ...initialData.columns,
          [newColumn.id]: newColumn,
        },
      };

      setData(newState);
      return;
    }

    // Moving from one list to another and swap last elements
    const startReportIds = Array.from(start.reportIds);
    startReportIds.splice(source.index, 1);

    const finishReportIds = Array.from(finish.reportIds);
    finishReportIds.splice(destination.index, 0, draggableId);
    const last_from_destination = finishReportIds.pop()
    const newFinish = {
      ...finish,
      reportIds: finishReportIds,
    };

    startReportIds.push(last_from_destination)
    const newStart = {
      ...start,
      reportIds: startReportIds,
    };

    const newState = {
      ...initialData,
      columns: {
        ...initialData.columns,
        [newStart.id]: newStart,
        [newFinish.id]: newFinish,
      },
    };
    setData(newState);
    setSaveDashboardSettingToggle(true)
    console.log(newState)
  };

  let noAccessRestratiner = true

  if (allReportsFlag.length == 0) {
    setTimeout(() => {
      noAccessRestratiner = false
    }, 2000);
    if (!noAccessRestratiner) {
      return (
        <NoAccessPopup
          featurename={"any reports"}
        />
      )
    }
  }

  return (
    <>
      <Row className="no-gutter" style={{padding: "0px 10px"}}>
        <Col md={6} className="flex-row-center-start">
          <Switch isToggled={reportToggle} onToggle={viewReports}></Switch>
          <p className="display-6" style={{ marginLeft: 20 }}>Intelligence Dashboard</p>
        </Col>
        <Col md={6} className="flex-row-center-end">
          <DropdownButton
            as={ButtonGroup}
            key="down-centered"
            id="dashboard-config"
            title="Configure dashboard"
            className="configure-dashboard"
          >
            <Dropdown.Item eventKey="1" className="save-changes-1">
              <Button className="save-button" onClick={() => saveDashboardViewSettings(reportToggle, initialData)}>
                Make &nbsp;{reportToggle ? <Icon.HeartFill style={{ fill: "#bd0155" }} /> : <Icon.Stack />}&nbsp; default view
              </Button>

            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item eventKey="2" className="save-changes-2"><Button className="save-button" onClick={() => saveDashboardSettings(initialData)}>Save configuration</Button></Dropdown.Item>
          </DropdownButton>
        </Col>
        {reportToggle
          ?
          <>
            <Row className="dashboard-row">
              {
                reportView.length > 0 &&
                reportView.map((report, index) => (
                  <ReportCard report={report} key={index} />
                ))
              }
            </Row>
          </>
          :
          <>
            <Row style={{margin:"-10px 0px 0px -25px"}}>
              <DragDropContext onDragEnd={onDragEnd}>
                <DragDropContextContainer>
                  {initialData.columnOrder.map(columnId => {
                    const column = initialData.columns[columnId];
                    const reports = column.reportIds.map(reportId => initialData.reports[reportId]);
                    return <Column key={column.id} column={column} reports={reports} />;
                  })}
                </ DragDropContextContainer>
              </DragDropContext>
            </Row>
          </>
        }
      </Row>
    </>
  );
};

export default ReportDashboard;
